import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './router-config';
import {LoadingBar} from 'view-design';
// import store from '@/store';
Vue.use(VueRouter)

const router = new VueRouter({
    // mode: 'history',
//   base: process.env.BASE_URL,
    routes
})
LoadingBar.config({
    color: '#3366ff',
    failedColor: '#CE040F',
    height: 5
});
router.beforeEach((to, from, next) => {
    LoadingBar.start();
    next();
    // if (to.meta.token && !getToken()) {
    //     store.commit('set_prev_page', {
    //         name: to.name,
    //         query: to.query,
    //         params: to.params
    //     });
    //     next({name: 'login', query: {back: 2}});
    // } else if (to.name === 'login' && getToken()) {
    //     next({name: 'home'});
    // } else next();
});

router.afterEach(to => {
    if (to.meta.title) {
        window.document.title = to.meta.title;
    } else {
        window.document.title = '数城科技';
    }
    LoadingBar.finish();
    document.getElementById('app').scrollTop = 0;
    // window.scrollTo(0, 0);
});
export default router